// CustomButton.js

import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/system";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
const StyledButton = styled(Button)(({ backgroundColor, hoverBackground }) => ({
  background: backgroundColor || "#4CAF50",
  border: 0,
  color: "white",
  padding: "0 30px",
  margin: "auto",
  height: "43px",
  borderRadius: "4px",
  marginTop: "20px",
  width: "100%",
  display: "flex",
  marginBottom: "10px",
  "&:hover": {
    background: hoverBackground || "#3d8b40",
  },
}));

const CustomButton = ({
  onClick,
  children,
  hideIcon,
  backgroundColor,
  hoverBackground,
}) => {
  return (
    <StyledButton
      variant="contained"
      onClick={onClick}
      backgroundColor={backgroundColor}
      hoverBackground={hoverBackground}
      sx={{
        fontSize: "12px",
        fontWeight: "700",
      }}
    >
      {!hideIcon && <AddOutlinedIcon sx={{ fontSize: "16px" }} />}
      {children}
    </StyledButton>
  );
};

export default CustomButton;
